/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { LogContentResponse } from '../models/log-content-response';
import { LogListResponse } from '../models/log-list-response';

@Injectable({
  providedIn: 'root',
})
export class LogsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getLogFiles
   */
  static readonly GetLogFilesPath = '/api/logs/files';

  /**
   * Get list of log files.
   *
   * Get list of available log files
   * Only users with ADMIN role can access this endpoint
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLogFiles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLogFiles$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<LogListResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LogsService.GetLogFilesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LogListResponse>;
      })
    );
  }

  /**
   * Get list of log files.
   *
   * Get list of available log files
   * Only users with ADMIN role can access this endpoint
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLogFiles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLogFiles(params?: {
  },
  context?: HttpContext

): Observable<LogListResponse> {

    return this.getLogFiles$Response(params,context).pipe(
      map((r: StrictHttpResponse<LogListResponse>) => r.body as LogListResponse)
    );
  }

  /**
   * Path part for operation getLogContent
   */
  static readonly GetLogContentPath = '/api/logs/content';

  /**
   * Get log file content.
   *
   * Get content of a specific log file
   * Only users with ADMIN role can access this endpoint
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLogContent()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLogContent$Response(params: {

    /**
     * Name of the log file to retrieve
     */
    filename: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<LogContentResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LogsService.GetLogContentPath, 'get');
    if (params) {
      rb.query('filename', params.filename, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LogContentResponse>;
      })
    );
  }

  /**
   * Get log file content.
   *
   * Get content of a specific log file
   * Only users with ADMIN role can access this endpoint
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLogContent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLogContent(params: {

    /**
     * Name of the log file to retrieve
     */
    filename: string;
  },
  context?: HttpContext

): Observable<LogContentResponse> {

    return this.getLogContent$Response(params,context).pipe(
      map((r: StrictHttpResponse<LogContentResponse>) => r.body as LogContentResponse)
    );
  }

}
